import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import LoginPage from './components/Login.vue'
import OrderBillingPage from './components/OrderBilling.vue'
import service from './api/axios'

// 将axios实例挂载到Vue原型上
Vue.prototype.$axios = service


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'LoginPage',
    component: LoginPage
  },
  {
    path: '/order-billing',
    name: 'OrderBillingPage',
    component: OrderBillingPage
  }
]

const router = new VueRouter({
  routes
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
